import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildSnapshotFromItinerary, BuildSnapshotOptions } from '../utils/snapshotBuilder';
import { generatePreviewId, savePreviewDraft } from '../utils/previewStorage';
import { PreviewItineraryPayload, TravelPostPreviewDraft } from '../types';

export interface LaunchPreviewParams extends BuildSnapshotOptions {}

const clonePreviewItinerary = (itinerary: any | undefined | null): PreviewItineraryPayload | undefined => {
  if (!itinerary) return undefined;
  try {
    const serializable = {
      title: itinerary.title || itinerary.name || null,
      summary: itinerary.summary || itinerary.description || null,
      city: itinerary.location || itinerary.destination_city || itinerary.custom_city || null,
      coverImage: itinerary.cover_image || itinerary.hero_image || itinerary.banner_image || itinerary.bgImage || null,
      days: Array.isArray(itinerary.days) ? itinerary.days : [],
    };
    const cloned = JSON.parse(JSON.stringify(serializable));
    cloned.days = Array.isArray(cloned.days) ? cloned.days : [];
    return cloned;
  } catch (err) {
    console.warn('[useTravelPostPreviewLauncher] failed to clone itinerary for preview', err);
    return undefined;
  }
};

export const useTravelPostPreviewLauncher = () => {
  const navigate = useNavigate();

  return useCallback((params: LaunchPreviewParams) => {
    const snapshot = buildSnapshotFromItinerary(params);
    if (!snapshot.days.length) {
      alert('目前行程沒有可以轉成遊記的內容');
      return;
    }

    const draftId = generatePreviewId();
    const draft: TravelPostPreviewDraft = {
      ...snapshot,
      draftId,
      sourceItineraryId: params.sourceItineraryId || undefined,
      previewItinerary: clonePreviewItinerary(params.itinerary),
    };
    savePreviewDraft(draft);
    navigate(`/travel-post/preview/${draftId}`);
  }, [navigate]);
};
